import BrontoIdleFrontSpriteData from "./Bronto/Idle/Bronto_Idle_Front_spritesheet.json";
import BrontoWalkFrontSpriteData from "./Bronto/Walk/Bronto_Walk_Front_spritesheet.json";

import RexIdleFrontSpriteData from "./Rex/Idle/Rex_Idle_Front_spritesheet.json";
import LaylaIdleFrontSpriteData from "./Layla/Idle/Layla_Idle_Front_spritesheet.json";
import PterryIdleFrontSpriteData from "./Pterry/Idle/Pterry_Idle_Front_spritesheet.json";
import StegoIdleFrontSpriteData from "./Stego/Idle/Stego_Idle_Front_spritesheet.json";
import AmberIdleFrontSpriteData from "./Amber/Idle/Amber_Idle_Front_spritesheet.json";
import DrakeIdleFrontSpriteData from "./Drake/Idle/Drake_Idle_Front_spritesheet.json";
import SammieSwirlIdleFrontSpriteData from "./SammieSwirl/Idle/SammieSwirl_Idle_Front_spritesheet.json";
import MikkoIdleFrontSpriteData from "./Mikko/Idle/Mikko_Idle_Front_spritesheet.json";
import JestyIdleFrontSpriteData from "./Jesty/Idle/Jesty_Idle_Front_spritesheet.json";
import ShiloIdleFrontSpriteData from "./Shilo/Idle/Shilo_Idle_Front_spritesheet.json";
import KallieIdleFrontSpriteData from "./Kallie/Idle/Kallie_Idle_Front_spritesheet.json";
import MarmaladeIdleFrontSpriteData from "./Marmalade/Idle/Marmalade_Idle_Front_spritesheet.json";
import RockyIdleFrontSpriteData from "./Rocky/Idle/Rocky_Idle_Front_spritesheet.json";
import CherryIdleFrontSpriteData from "./Cherry/Idle/Cherry_Idle_Front_spritesheet.json";
import SolaraIdleFrontSpriteData from "./Solara/Idle/Solara_Idle_Front_spritesheet.json";
import SirGlintIdleFrontSpriteData from "./SirGlint/Idle/SirGlint_Idle_Front_spritesheet.json";
import PoppyIdleFrontSpriteData from "./Poppy/Idle/Poppy_Idle_Front_spritesheet.json";

import TammyIdleFrontSpriteData from "./Tammy/Idle/Tammy_Idle_Front_spritesheet.json";

import WillowIdleFrontSpriteData from "./Willow/Idle/Willow_Idle_Front_spritesheet.json";

// import BrontoWalkRightSpriteData from "./Bronto/Walk/Bronto_Walk_Right_spritesheet.json"

interface FrameData {
  x: number;
  y: number;
  w: number;
  h: number;
}

interface Frame {
  frame: FrameData;
  rotated: boolean;
  trimmed: boolean;
  spriteSourceSize: FrameData;
  sourceSize: { w: number; h: number };
}

interface SpriteSheetData {
  frames: { [key: string]: Frame };
  meta: {
    app: string;
    version: string;
    image: string;
    format: string;
    size: { w: number; h: number };
    scale: string;
  };
}

interface AnimationSetting {
  frames: { [key: string]: Frame };
  frameRate: number;
  spriteSheet: string;
  spriteData: SpriteSheetData;
}

type CharacterAnimations = {
  [character: string]: {
    [animation: string]: AnimationSetting;
  };
};

// Now use CharacterAnimations for characterAnimations

const characterAnimations: CharacterAnimations = {
  Bronto: {
    idleFront: {
      frames: BrontoIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Bronto_Idle_Front_Spritesheet.png",
      spriteData: BrontoIdleFrontSpriteData,
    },
    walkFront: {
      frames: BrontoWalkFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Bronto_Walk_Front_Spritesheet.png",
      spriteData: BrontoWalkFrontSpriteData,
    },
    // other Bronto animations...
  },

  Rex: {
    idleFront: {
      frames: RexIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Rex_Idle_Front_Spritesheet.png",
      spriteData: RexIdleFrontSpriteData,
    },
  },

  Layla: {
    idleFront: {
      frames: LaylaIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Layla_Idle_Front_Spritesheet.png",
      spriteData: LaylaIdleFrontSpriteData,
    },
  },
  Pterry: {
    idleFront: {
      frames: PterryIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Pterry_Idle_Front_Spritesheet.png",
      spriteData: PterryIdleFrontSpriteData,
    },
  },

  Stego: {
    idleFront: {
      frames: StegoIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Stego_Idle_Front_Spritesheet.png",
      spriteData: StegoIdleFrontSpriteData,
    },
  },
  Amber: {
    idleFront: {
      frames: AmberIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Amber_Idle_Front_Spritesheet.png",
      spriteData: AmberIdleFrontSpriteData,
    },
  },
  Drake: {
    idleFront: {
      frames: DrakeIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Drake_Idle_Front_Spritesheet.png",
      spriteData: DrakeIdleFrontSpriteData,
    },
  },
  SammieSwirl: {
    idleFront: {
      frames: SammieSwirlIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/SammieSwirl_Idle_Front_Spritesheet.png",
      spriteData: SammieSwirlIdleFrontSpriteData,
    },
  },
  Mikko: {
    idleFront: {
      frames: MikkoIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Mikko_Idle_Front_Spritesheet.png",
      spriteData: MikkoIdleFrontSpriteData,
    },
  },
  Jesty: {
    idleFront: {
      frames: JestyIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Jesty_Idle_Front_Spritesheet.png",
      spriteData: JestyIdleFrontSpriteData,
    },
  },
  Shilo: {
    idleFront: {
      frames: ShiloIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Shilo_Idle_Front_Spritesheet.png",
      spriteData: ShiloIdleFrontSpriteData,
    },
  },
  Kallie: {
    idleFront: {
      frames: KallieIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Kallie_Idle_Front_Spritesheet.png",
      spriteData: KallieIdleFrontSpriteData,
    },
  },
  Marmalade: {
    idleFront: {
      frames: MarmaladeIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Marmalade_Idle_Front_Spritesheet.png",
      spriteData: MarmaladeIdleFrontSpriteData,
    },
  },
  Rocky: {
    idleFront: {
      frames: RockyIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Rocky_Idle_Front_Spritesheet.png",
      spriteData: RockyIdleFrontSpriteData,
    },
  },
  Cherry: {
    idleFront: {
      frames: CherryIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Cherry_Idle_Front_Spritesheet.png",
      spriteData: CherryIdleFrontSpriteData,
    },
  },
  Solara: {
    idleFront: {
      frames: SolaraIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Solara_Idle_Front_Spritesheet.png",
      spriteData: SolaraIdleFrontSpriteData,
    },
  },
  SirGlint: {
    idleFront: {
      frames: SirGlintIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/SirGlint_Idle_Front_Spritesheet.png",
      spriteData: SirGlintIdleFrontSpriteData,
    },
  },
  Poppy: {
    idleFront: {
      frames: PoppyIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Poppy_Idle_Front_Spritesheet.png",
      spriteData: PoppyIdleFrontSpriteData,
    },
  },
  Tammy: {
    idleFront: {
      frames: TammyIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Tammy_Idle_Front_Spritesheet.png",
      spriteData: TammyIdleFrontSpriteData,
    },
  },
  Willow: {
    idleFront: {
      frames: WillowIdleFrontSpriteData.frames,
      frameRate: 24,
      spriteSheet:
        "https://moonrock-images.s3.us-east-2.amazonaws.com/Willow_Idle_Front_Spritesheet.png",
      spriteData: WillowIdleFrontSpriteData,
    },
  },
};

export { characterAnimations };
